<main>
  <app-nav-bar-main-login ></app-nav-bar-main-login>
  <div class="container">
    <div class="priv-container container-padding">
      <div class="sect">
        <h1 class="priv-heading">
          Pricing
        </h1>
        <div>
          <ul>
            <li>- Our starting price starts from the PKR 20,000 and its can go uptill PKR 20,000,000 depending upon the segment and date chosen for Flight and Visa.</li>
            <li>- Discount is not applicable on Taxes and Convenience Fee (bank transaction charges).</li>
            <li>- No discount will be applied on any changes related to dates, no. of people and any other subject after booking.</li>
            <li>- All prices and offers are subject to change with availability.</li>

          </ul>
        </div>
      </div>
      <!--<div class="bottom-sect">
        <a class="boldnblue" href="/">Supplier terms <span> &#187;</span></a>
      </div>-->
      <div class="sect bottom-sect">

        <!--<p class="pol-statement">This website is owned and operated by B2BTravelSolutions PTE Ltd., a global enterprise registered in UAE. The Terms of Use and the provision of services will be governed by and construed in accordance with the laws of UAE.</p>

        <div><a class="boldnblue" href="/">UAE Travel Agents Act 1***</a></div>

        <div><a class="boldnblue" href="/">UAE Travel Agents Regulations 2***</a></div>

        <div>B2BTravelSolutions operates into the following markets-</div>
        <div class="mt-2">
          <div class="blacknbold">United Arab Emirates</div>
          <div class="address">97 Buraq Ave. # 02-50</div>
          <div class="address">Al Hamrah, UAE 544706.</div>
        </div>
        <div class="mt-3">
          <div class="blacknbold">Pakistan</div>
          <div class="term-agn-name">B2BTravelSolutions PK (Private) Limited</div>
          <div class="address">Office 6, 3rd floor, Gohar centre, main Wahdat road, new Muslim town, Lahore.</div>
        </div>-->
      </div>

    </div>
  </div>
  <app-footer></app-footer>
</main>
